class UserModel {
  constructor(data) {
    this.id = data.id || null;
    this.email = data.email || null;
    this.nom_complet = data.nom_complet || null;
    this.nom_commercial = data.nom_commercial || null;
    this.email_verified = Boolean(data.email_verified);
    this.capital = data.capital || null;
    this.forme_juridique = data.forme_juridique || null;

    // TVA
    this.tva_inclus = Boolean(data.tva_inclus);
    this.tva_rates = data.tva_rates || {};

    // Infos légales
    this.siret = data.siret || null;
    this.numero_tva = data.numero_tva || null;

    // Adresse
    this.adresse_ligne1 = data.adresse_ligne1 || null;
    this.adresse_ligne2 = data.adresse_ligne2 || null;
    this.code_postal = data.code_postal || null;
    this.ville = data.ville || null;
    this.code_pays = data.code_pays || "FR";
    this.code_promo_utilise = data.code_promo_utilise || null;
    // Contact
    this.telephone = data.telephone || null;
    this.photo_profil =
      data.photo_profil || null;
    this.fcm_token = data.fcm_token || null;

    // Abonnement
    this.current_plan = data.current_plan || "basic";
    this.plan_debut = data.plan_debut || null;
    this.plan_fin = data.plan_fin || null;
    this.plan_interval = data.plan_interval || "monthly"; // mensuel par défaut
    this.prochain_paiement = data.prochain_paiement || null;
    this.abonnement_annule = Boolean(data.abonnement_annule);

    // Stripe
    this.stripe_customer_id = data.stripe_customer_id || null;
    this.stripe_sub_id = data.stripe_sub_id || null;

    // Options
    this.logo_inclus_pdf = Boolean(data.logo_inclus_pdf);
    this.rib = data.rib || null;
    this.rib_masked = this.rib;
    this.email_comptable = data.email_comptable || null;
    this.password_comptable = data.password_comptable || null;
    this.code_invitation_comptable = data.code_invitation_comptable || null;
    this.devise = data.devise || "€";

    // Paiements
    this.paiements = Array.isArray(data.paiements)
      ? data.paiements.map((p) => ({
        id: p.id || null,
        fournisseur_paiement_id: p.fournisseur_paiement_id || null,
        statut: p.statut || "en_attente",
        date_paiement: p.date_paiement || null,
        montant: p.montant || null,
        prochain_paiement: p.prochain_paiement || null,
        billing: p.billing || "monthly", // mensuel par défaut
      }))
      : [];

    // Statut comptable
    this.comptable_status = {
      email_envoye: Boolean(data.comptable_status?.email_envoye),
      connecte: Boolean(data.comptable_status?.connecte),
    };

    // Métadonnées
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
  }



}

export default UserModel;
